import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

type Props = JSX.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

export function AirtableLink(props: Props) {
  const [local, rest] = splitProps(props, ['class', 'children']);
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      class={classNames('underline-offset-2 hover:underline', local.class)}
      {...rest}
    >
      {local.children}
    </a>
  );
}
